import diana from "../../../image/originals/hollywoodicons/diana.webp"; 
import ItemNoSize from "../ItemNoSize";

const Shop = () => {
  const items = [
    {
      id: "84_base",
      name: "Princess Diana Print",
      image: diana, // Main image without .webp
      price: "empty for now",
      thumbnails: [diana], // Other images (if available)
      description: 'Roughly 20" x 20" Museum Rag Paper.',
      projectUrl: "/PrincessDianaPrint",
      sizes: ["blank"],
    },
  ];

  return <ItemNoSize items={items} />;
};

export default Shop;
